/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Role_LabelInputs */



/**
* | output |
* | --- |
* | "User Role" |
*
* @param {Team_Manager_User_Role_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_role_label = /** @type {((inputs?: Team_Manager_User_Role_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Role_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rôle utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerrolle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ruolo utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Роль пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rol de usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户角色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーロール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता भूमिका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Função do usuário")
	return /** @type {LocalizedString} */ ("User Role")
});